import { render, staticRenderFns } from "./GanttInOne.vue?vue&type=template&id=2ef4aa52&scoped=true&"
import script from "./GanttInOne.vue?vue&type=script&lang=js&"
export * from "./GanttInOne.vue?vue&type=script&lang=js&"
import style0 from "./GanttInOne.vue?vue&type=style&index=0&id=2ef4aa52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4aa52",
  null
  
)

export default component.exports